import { Controller } from "@hotwired/stimulus"
import {
  listOutboxEntriesForCurrentPartition,
  discardOutboxEntry,
  OUTBOX_STATUS_EVENT
} from "../pwa/outbox"

// 事件詳細に、当該 matter の送信待ち Trial/Meeting を重ねて表示する。
export default class extends Controller {
  static values = {
    matterId: Number,
    queuedLabel: { type: String, default: "送信待ち" },
    failedLabel: { type: String, default: "失敗" },
    discardLabel: { type: String, default: "破棄" },
    scheduleTypeLabels: Object
  }
  static targets = ["list"]

  connect() {
    this.refresh = this.refresh.bind(this)
    window.addEventListener(OUTBOX_STATUS_EVENT, this.refresh)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener(OUTBOX_STATUS_EVENT, this.refresh)
  }

  async refresh() {
    if (!this.hasListTarget) return
    const matterId = String(this.matterIdValue)
    const rows = (await listOutboxEntriesForCurrentPartition()).filter(
      (entry) => String(entry.payload?.matter_id || "") === matterId
    )

    this.listTarget.replaceChildren()
    // Bootstrapのテーブル表示でもラベルごと隠れるよう、displayも切り替える。
    this.element.hidden = rows.length === 0
    this.element.style.display = rows.length === 0 ? "none" : ""
    if (rows.length === 0) return

    for (const entry of rows) {
      const row = document.createElement("div")
      row.className = "offline-outbox-item"
      const label = document.createElement("span")
      const scheduleType = entry.schedule_type || entry.payload?.type || "Schedule"
      const localizedType = this.hasScheduleTypeLabelsValue
        ? this.scheduleTypeLabelsValue[scheduleType] || scheduleType
        : scheduleType
      const title = `${localizedType} ${entry.payload?.start || ""}`.trim()
      const state =
        entry.state === "failed"
          ? this.formatFailedLabel(entry.last_error_code)
          : this.queuedLabelValue
      label.textContent = `${title} — ${state}`
      row.appendChild(label)

      if (entry.state === "failed") {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "btn btn-xs btn-link"
        button.textContent = this.discardLabelValue
        button.dataset.action = "offline-outbox-overlay#discard"
        button.dataset.offlineOutboxOverlayRequestIdParam = entry.request_id
        row.appendChild(button)
      }

      this.listTarget.appendChild(row)
    }
  }

  formatFailedLabel(code) {
    const template = this.failedLabelValue
    if (template.includes("%{code}")) {
      return template.replace("%{code}", code || "?")
    }
    return `${template}(${code || "?"})`
  }

  async discard(event) {
    const requestId = event.params.requestId
    if (!requestId) return
    await discardOutboxEntry(requestId)
    await this.refresh()
  }
}
